import React from 'react';
import {Checkbox, FormControl, Modal} from 'react-bootstrap';
import IOCloseCircled from 'react-icons/lib/io/close-circled';
import FaPlusCircle from 'react-icons/lib/fa/plus-circle';
import _ from 'lodash';
import {renderPayoutRules} from 'dashboard/sellers/renderPayoutRules';



export default class PayoutScaleEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      payoutRules: this.props.currentPayoutScale.Rules || [],
      payoutScaleActive: _.isUndefined(this.props.currentPayoutScale.Active) ? true : this.props.currentPayoutScale.Active
    };
  };


  addNewRule() {
    let payoutRulesToUpdate = [...this.state.payoutRules];
    payoutRulesToUpdate.splice(payoutRulesToUpdate.length - 1, 0, {
      newRule: true,
      value: '',
      conditions: [{number: '', operator: '>='}, {number: '', operator: '<'}]
    });
    this.setState({
      payoutRules: payoutRulesToUpdate
    });
  }

  deletePayoutRule(index) {
    this.setState({
      payoutRules: [...this.state.payoutRules.slice(0, index),
        ...this.state.payoutRules.slice(index + 1)]
    });
  }

  onPriceRangeAmountChange(value, index,  payoutRule,conditionIndex) {
      let payoutRuleToUpdate = {...payoutRule};
      payoutRuleToUpdate.conditions[conditionIndex].number = value;
      this.setState({
        payoutRules: [...this.state.payoutRules.slice(0, index),
          payoutRuleToUpdate,
          ...this.state.payoutRules.slice(index + 1)]
      });
    }
  onPayoutPercentageChange(value, index,  payoutRule) {
    let payoutRuleToUpdate = {...payoutRule, value: value};
    this.setState({
      payoutRules: [...this.state.payoutRules.slice(0, index),
        payoutRuleToUpdate,
        ...this.state.payoutRules.slice(index + 1)]
    });
  }
  render() {
    return <Modal
      backdrop={'static'}
      keyboard={false}
      show={this.props.showModal}
      onExited={this.props.onHide}
      dialogClassName=""
      onHide={this.props.onHide}>
      <Modal.Header closeButton>
        <Modal.Title className="text-center purple">{this.props.modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{height: 600, overflow: 'scroll'}}>
        <div className="flex-box  space-between bot20">
          <div style={{'width': '40%'}}>
            <div className="text-bold text-center bot30">Price Range</div>
            <div className="flex-box  space-between" style={{height: '30px'}}>
              <span style={{width: 23, visibility: 'hidden'}}>From =</span>
              <span style={{width: 60}} className="text-center">From =</span>
              <span style={{width: 60}} className="text-center">{'To <'}</span>
            </div>

          </div>
          <div style={{'width': '40%'}}>
            <div className="text-bold text-center bot30">Payout %</div>
            <div className="" style={{height: '30px'}}>
            </div>
          </div>
        </div>
        {renderPayoutRules({
          payoutRules:this.state.payoutRules,
          onPayoutPercentageChange:this.onPayoutPercentageChange.bind(this),
          onPriceRangeAmountChange:this.onPriceRangeAmountChange.bind(this),
          deletePayoutRule:this.deletePayoutRule.bind(this),
        })}
        <FaPlusCircle className="cursor-pointer"
                      onClick={() => this.addNewRule()}
                      style={{
                        height: '30px',
                        position: 'relative',
                        top: -2,
                        color: '#8DD6FE',
                        width: 23
                      }}></FaPlusCircle>
        <span className="cursor-pointer pleft10" ref="addNewRuleButton"
              onClick={() => this.addNewRule()} style={{color: '#2D9BF0'}}>Add new line</span>

        <Checkbox
          className="top20"
          ref="payoutScaleActiveCheckbox"
          onClick={() => {
            this.setState({
              payoutScaleActive: !this.state.payoutScaleActive,
            });
          }}
          checked={this.state.payoutScaleActive}>Payout scale enabled</Checkbox>

        <div className="flex-box justify-content-center top30">
          <button ref="savePayoutRuleButton" style={{width: 90}} className="top30 btn btn-primary"
                  onClick={() => this.props.submitPayoutRules({
                    ...this.props.currentPayoutScale,
                    Active: this.state.payoutScaleActive,
                    Rules: this.state.payoutRules
                  })}>Save
          </button>
        </div>
      </Modal.Body>
    </Modal>;
  }
}
